import React from 'react';
const skills = ['Comprensión lectora', 'Producción escrita', 'Técnicas de estudio', 'Aprender a estudiar', 'Pensamiento crítico', 'Orientación vocacional', 'Debate y argumentación', 'Inteligencia artificial aplicada al estudio'];
export function OverviewSection() {
  return <section className="py-10 px-4 bg-gray-50" data-id="element-84" data-mp="3hr3nuiiw7o08">
      <div className="max-w-5xl mx-auto text-center" data-id="element-85" data-mp="3hqbsn8t7jsah">
        <h2 className="text-2xl md:text-4xl font-black text-[#1B3A6B] mb-2 leading-tight" data-id="element-86" data-mp="3viib51ju2bd3">
          8 HABILIDADES. UN SOLO MATERIAL.
        </h2>
        <p className="text-lg text-gray-600 mb-8" data-id="element-87" data-mp="3rg53u8pfu5e7">
          Un recurso pensado para trabajar durante todo el año.
        </p>

        <div className="flex flex-col md:flex-row items-center gap-8" data-id="element-88" data-mp="997i3lv8gnfi">
          <div className="w-full md:w-1/2 flex justify-center" data-id="element-89" data-mp="4didv589qicv">
            <img src="https://cdn.magicpatterns.com/uploads/oqQ5tJksQY6ihcLkMfq1Ex/IMAGEN_PRINCIPAL.png" alt="8 Habilidades para Secundaria — material completo" className="w-full max-w-[420px] h-auto object-contain drop-shadow-2xl" data-id="element-90" data-mp="2b257f7pswxvp" />
          </div>

          <div className="w-full md:w-1/2 text-left" data-id="element-91" data-mp="2mzajyanti1mg">
            <ul className="space-y-2.5" data-id="element-92" data-mp="2rvr9n9ao0o1n">
              {skills.map(s => <li key={s} className="flex items-start text-base md:text-lg font-semibold text-gray-800" data-id="element-93" data-mp="2ru6epikfv339">
                  <span className="text-[#17A2AE] mr-2 font-black" data-id="element-94" data-mp="30ouit5ea2eqh">✔</span>
                  {s}
                </li>)}
            </ul>

            <p className="mt-6 text-xl md:text-2xl font-black text-[#1B3A6B]" data-id="element-95" data-mp="35oqln1b8o04g">
              116 páginas listas para imprimir y trabajar.
            </p>
          </div>
        </div>
      </div>
    </section>;
}